//External libraries
import styled from '@emotion/styled';

// Internal modules
import { FLAGS_SPRITE_URL, HEADER_COLOR, TEXT_COLOR } from '@/styles';

const Container = styled.div`
  margin: 0 auto;
  max-width: 1150px;
`;

const CountryGroupContainer = styled.div`
  &:not(:first-of-type) {
    margin-top: 30px;
  }
`;

const CountryGroupHeader = styled.h2`
  border-bottom: 1px solid rgba(74, 74, 74, 0.25);
  color: ${HEADER_COLOR};
  font-size: 20px;
  letter-spacing: 1px;
  line-height: 1.5;
  margin-bottom: 10px;

  @media (min-width: 500px) {
    font-size: 24px;
  }
`;

const CountryLink = styled.a`
  color: ${TEXT_COLOR};
  cursor: pointer;
  display: flex;
  padding: 5px;

  &:hover,
  &:focus {
    span {
      text-decoration: underline;
    }
  }
`;

const CountryList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const CountryListItem = styled.li`
  align-self: center;
  flex: 0 0 48%;
  font-size: 15px;
  line-height: 1.4;
  margin-bottom: 12px;
  min-height: 30px;

  @media (min-width: 380px) and (max-width: 699px) {
    flex: 0 0 30%;
  }

  @media (min-width: 700px) {
    flex: 0 0 20%;
  }
`;

const FlagIcon = styled.div`
  align-self: center;
  background-image: url(${FLAGS_SPRITE_URL});
  background-position: 0 ${props => props.bgPosition}px;
  background-repeat: no-repeat;
  flex: 0 0 22px;
  height: 18px;
  margin-right: 10px;
`;

const InterstitialFooter = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 30px 0;
`;

export {
  Container,
  CountryGroupContainer,
  CountryGroupHeader,
  CountryLink,
  CountryList,
  CountryListItem,
  FlagIcon,
  InterstitialFooter,
};
